/*
 payment/payment/lib/immediate_payment_result_router
 */
import constants from '../../common/lib/utils/constants.js';
import dataflow from '../../common/lib/dataflow.js';
import PaymentResult from './../../../components/payment-result.js';

// TODO: use view_spinner from view module. All domupdates are routed from the 'view.js'.
// import viewSpinner from './view-spinner.js';
// import viewSpinner from '../../commonview/lib/view-spinner.js';

const register = dataflow.register;

function registerActions() {
	function immediatePaymentResultRouter(payload) {
		// Only used for immediate results (in situations when not showing the provider page)
		if (payload.type === constants.ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL || payload.type === constants.RESULT_AFTER_SINGLE_CALL) {
			PaymentResult.functions.open(payload.paymentHandled);
		}
	}
	register(immediatePaymentResultRouter);
}

export default {
	init() {
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/immediate-payment-result-router.js